import { render, staticRenderFns } from "./Boxes.vue?vue&type=template&id=08639f3b&"
import script from "./Boxes.vue?vue&type=script&lang=ts&"
export * from "./Boxes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports